type PropsType = {
  stroke?: string;
  styles?: any;
};

const ArrowSwitchIcon = ({ stroke, styles }: PropsType) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
    >
      <path
        d="M12.5 2.25L15.5 5.25M15.5 5.25L12.5 8.25M15.5 5.25H3.5M6.5 15.75L3.5 12.75M3.5 12.75L6.5 9.75M3.5 12.75H15.5"
        stroke={stroke || '#788496'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ArrowSwitchIcon;
